/* DeskRebel Luxury Edition — Theme JS */
window.DeskRebel = window.DeskRebel || {};

document.addEventListener('DOMContentLoaded', function() {

  /* ========= Sticky Header ========= */
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ========= Mobile Menu ========= */
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileClose = document.getElementById('mobile-close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function() {
      var isOpen = mobileNav.classList.toggle('active');
      hamburger.classList.toggle('active', isOpen);
      mobileNav.setAttribute('aria-hidden', String(!isOpen));
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function() {
      mobileNav.classList.remove('active');
      if (hamburger) hamburger.classList.remove('active');
      mobileNav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  }

  /* ========= Cart Count ========= */
  DeskRebel.updateCartCount = function(count) {
    var el = document.getElementById('cart-count');
    if (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    }
  };

  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(d) {
    DeskRebel.updateCartCount(d.item_count);
  });

  /* ========= Toast ========= */
  DeskRebel.showToast = function(msg, type) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.className = 'toast ' + (type || 'success') + ' show';
    clearTimeout(DeskRebel._toastTimer);
    DeskRebel._toastTimer = setTimeout(function() { toast.className = 'toast'; }, 3500);
  };

  /* ========= Add to Cart ========= */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    var qty = 1;
    var form = btn.closest('form');
    if (form) {
      var qEl = form.querySelector('[name="quantity"], .qty-input, .quantity-input');
      if (qEl) qty = parseInt(qEl.value) || 1;
    }
    var origText = btn.textContent;
    btn.textContent = 'Wird hinzugefügt…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() { return fetch('/cart.js'); })
    .then(function(r) { return r.json(); })
    .then(function(d) {
      DeskRebel.updateCartCount(d.item_count);
      DeskRebel.showToast('Zum Warenkorb hinzugefügt', 'success');
      btn.textContent = origText;
      btn.disabled = false;
    })
    .catch(function() {
      DeskRebel.showToast('Fehler beim Hinzufügen.', 'error');
      btn.textContent = origText;
      btn.disabled = false;
    });
  });

  /* ========= Qty Buttons ========= */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.quantity-btn, .cart-qty-btn, .qty-btn');
    if (!btn) return;
    var isIncrease = btn.dataset.action === 'increase' || btn.textContent.trim() === '+';
    var wrap = btn.closest('.quantity-selector, .cart-quantity, .qty-input-wrap');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value) || 1;
    input.value = isIncrease ? val + 1 : Math.max(1, val - 1);
    input.dispatchEvent(new Event('change'));
  });

  /* ========= Cart Page ========= */
  document.addEventListener('change', function(e) {
    var input = e.target.closest('.cart-qty-input');
    if (!input) return;
    var lineIndex = input.dataset.line;
    if (!lineIndex) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: parseInt(input.value) || 0 })
    }).then(function() { location.reload(); });
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-remove-btn');
    if (!btn) return;
    var lineIndex = btn.dataset.line;
    if (!lineIndex) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    }).then(function() { location.reload(); });
  });

  /* ========= Product Tabs ========= */
  document.querySelectorAll('.tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var container = this.closest('.product-tabs');
      if (!container) return;
      container.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
      container.querySelectorAll('.tab-content').forEach(function(c) { c.classList.remove('active'); });
      this.classList.add('active');
      var tc = container.querySelector('[data-tab-content="' + this.dataset.tab + '"]');
      if (tc) tc.classList.add('active');
    });
  });

  /* ========= Scroll Reveal (.reveal + .animate-on-scroll) ========= */
  if ('IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    var scrollObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          scrollObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    document.querySelectorAll('.reveal').forEach(function(el) { revealObs.observe(el); });
    document.querySelectorAll('.animate-on-scroll').forEach(function(el) { scrollObs.observe(el); });
  } else {
    document.querySelectorAll('.reveal, .animate-on-scroll').forEach(function(el) {
      el.classList.add('visible', 'in-view');
    });
  }

  /* ========= Stats Counter ========= */
  var statEls = document.querySelectorAll('.stat-number[data-target]');
  if (statEls.length && 'IntersectionObserver' in window) {
    var statsObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.dataset.target);
        var start = 0;
        var step = target / (1500 / 16);
        var suffix = el.innerHTML.replace(/[0-9]/g, '').trim();
        var timer = setInterval(function() {
          start = Math.min(start + step, target);
          el.innerHTML = Math.round(start) + suffix;
          if (start >= target) clearInterval(timer);
        }, 16);
        statsObs.unobserve(el);
      });
    }, { threshold: 0.5 });
    statEls.forEach(function(el) { statsObs.observe(el); });
  }

  /* ========= Back to Top ========= */
  var backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', function() {
      backToTop.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
    backToTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ========= Scroll Progress ========= */
  var progressBar = document.getElementById('scroll-progress');
  if (progressBar) {
    window.addEventListener('scroll', function() {
      var progress = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      progressBar.style.width = (isNaN(progress) ? 0 : progress) + '%';
    }, { passive: true });
  }

  /* ========= Cookie Consent ========= */
  var cookieBanner = document.getElementById('cookie-banner');
  if (cookieBanner && !localStorage.getItem('dr_cookies_accepted')) {
    setTimeout(function() { cookieBanner.classList.add('visible'); }, 1800);
    var acceptBtn = document.getElementById('cookie-accept');
    var declineBtn = document.getElementById('cookie-decline');
    function dismissCookie(val) {
      localStorage.setItem('dr_cookies_accepted', val);
      cookieBanner.classList.remove('visible');
      setTimeout(function() { cookieBanner.style.display = 'none'; }, 500);
    }
    if (acceptBtn) acceptBtn.addEventListener('click', function() { dismissCookie('all'); });
    if (declineBtn) declineBtn.addEventListener('click', function() { dismissCookie('essential'); });
  }

});
